// Cursos que Solar Hub carga al técnico. Se financian con el 30% del 20%
// de reinversión de cada obra (capacitaciones), no con el 80% del técnico.

export const CURSOS_TECNICO = [
  {
    id: 'retie-fv',
    eje: 'Normativa',
    titulo: 'RETIE aplicado a sistemas fotovoltaicos',
    horas: 8,
    estado: 'disponible',
    desc: 'Requisitos de instalación, protecciones y acta de conformidad.',
  },
  {
    id: 'modelado-8760',
    eje: 'Herramientas',
    titulo: 'Modelado horario 8760 y sombras',
    horas: 6,
    estado: 'disponible',
    desc: 'Usar el estudio: TMY, pérdidas, P50/P90 y cómo explicarlo al cliente.',
  },
  {
    id: 'creg-agpe',
    eje: 'Normativa',
    titulo: 'CREG 174 y AGPE en campo',
    horas: 4,
    estado: 'proximo',
    desc: 'Excedentes, menor/mayor y qué debe quedar en la propuesta.',
  },
  {
    id: 'unifilar-memoria',
    eje: 'Ingeniería',
    titulo: 'Unifilar y memoria técnica',
    horas: 5,
    estado: 'proximo',
    desc: 'Leer y entregar el paquete técnico que sale del modelado.',
  },
  {
    id: 'pqr-posventa',
    eje: 'Servicio',
    titulo: 'PQR y posventa de excelencia',
    horas: 3,
    estado: 'disponible',
    desc: 'Tickets, tiempos de respuesta y cierre de soporte.',
  },
  {
    id: 'seguridad-obra',
    eje: 'Campo',
    titulo: 'Seguridad en obra fotovoltaica',
    horas: 4,
    estado: 'proximo',
    desc: 'Alturas, DC en tensión y entrega segura al cliente.',
  },
];

export function etiquetaEstadoCurso(estado) {
  if (estado === 'disponible') return 'Disponible';
  if (estado === 'proximo') return 'Se carga pronto';
  return 'En preparación';
}
